import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../services/axiosInstance";
import * as StorageManager from "../utils/StorageManager";
import constants from "../constants";
import * as depositSelectors from "../selectors/e-deposit";
import * as depositActions from "../action/deposit";

export const withDepositConfig = (WrappedComponent) => {
    function WithDepositConfig(props) {
        const depositConfigData = useSelector((state) => depositSelectors.getDepositConfigData(state));
        const dispatch = useDispatch();
        const [token, setToken] = useState(null);

        useEffect(() => {
            StorageManager.retrieveToken(constants.AUTH_TOKEN).then((value) => {
                setToken(value);
            });
        }, []);

        const { isLoading, data } = useQuery({
            queryKey: ["deposit-config-data"],
            queryFn: async () => {
                try {
                    return await axiosInstance.get(`/clientarea/deposit/config`);
                } catch (e) {}
            },
            retryDelay: 15000,
            enabled: !_.isEmpty(token) && _.isEmpty(depositConfigData),
        });

        useEffect(() => {
            dispatch(depositActions.setDepositConfigData(data));
        }, [data]);

        return <WrappedComponent {...props} loading={isLoading} depositConfig={depositConfigData} />;
    }

    return WithDepositConfig;
};
